import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../config/firebase";
import NavBar from "../components/navbar";

import { doc, setDoc, collection } from "firebase/firestore";

export default function AddStudent({ user }) {
  const [userId, setUserId] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState(""); // Birthdate state
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setUserId(user.uid);
    }
  }, [user]);

  const addStudent = async (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !age || !birthdate) {
      setError("Please fill in all mandatory fields: First Name, Last Name, Age, and Birthdate.");
      return;
    }

    try {
      const studentData = {
        name: firstName,
        middleName: middleName || null,
        lastName: lastName,
        age: age,
        birthdate: birthdate,
      };

      const userRef = doc(db, "Users", userId);
      const studentscol = collection(userRef, "Students");
      const studentsRef = doc(studentscol);

      await setDoc(studentsRef, studentData);
      navigate("/dashboard");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="add-student-page">
      <NavBar />

      <form className="add-student-form">
        <h2>Add Student</h2>
        <input
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="First Name"
        />
        <input
          type="text"
          value={middleName}
          onChange={(e) => setMiddleName(e.target.value)}
          placeholder="Middle Name (Optional)"
        />
        <input
          type="text"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="Last Name"
        />
        <input
          type="number"
          value={age}
          onChange={(e) => setAge(e.target.value)}
          placeholder="Age"
        />
        <input
          type="date"
          value={birthdate}
          onChange={(e) => setBirthdate(e.target.value)}
          placeholder="Birthdate"
        />
        <button type="submit" onClick={(e) => addStudent(e)}>
          Add Student
        </button>
      </form>
      {error && <p className="error-message">{error}</p>}
      <style jsx>{`
        .add-student-page {
          background-color: #f9fbfd;
          min-height: 100vh;
          padding-top: 70px; /* Space below navbar */
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }

        .add-student-form {
          width: 90%;
          max-width: 600px;
          padding: 20px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          margin-top: 10px; /* Slight gap below navbar */
        }

        .add-student-form h2 {
          margin-bottom: 20px;
          text-align: center;
          color: #2c3e50;
        }

        .add-student-form input {
          width: calc(100% - 20px);
          margin-bottom: 15px;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 1rem;
        }

        .add-student-form button {
          width: 100%;
          padding: 10px 20px;
          background-color: #6a5acd;
          color: #fff;
          border: none;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .add-student-form button:hover {
          background-color: #5a4dbb;
        }

        .error-message {
          color: red;
          margin-top: 10px;
          text-align: center;
        }
      `}</style>
    </div>
  );
}
